module.exports = "data:image/png;base64,UklGRtQAAABXRUJQVlA4WAoAAAAQAAAALwAALwAAQUxQSI0AAAABZ6AokqQ2ffmOHAwggBceiIgA+1jPxotvBdzWtq1ED3cphBK0CTKNacCLoAQiYkqw8ZmuFJcsov+K3LZtpFOS7vEJmJcm3ncNFdd3DTU/5hrk8tXDAAHwX70kAQqlT9CxHxNATn/zsQao+Y8Wf50dWdjD65tXL9/YVg/P/Qc69BRqHzq2/38c8H8XKwAAVlA4ICAAAACwAQCdASowADAAAAAAJaQAA8lomMsAAP7/327UAAAAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/p12.png
// module id = T4kE
// module chunks = 1